"use strict";
import { defineComponent, onMounted, onBeforeUnmount, inject } from "vue";
import { Captcha } from "@/presentation/components/Form/Input/Captcha/Captcha.class";
import globals from "@/utils/globals";
import { setupComponent } from "@studyportals/vue-platform";
export default defineComponent({
  setup: () => {
    const captchaInstance = inject("captchaInstance", globals.globalStoreCaptcha);
    const component = new Captcha(captchaInstance);
    onMounted(component.mounted.bind(component));
    onBeforeUnmount(component.beforeUnmount.bind(component));
    return setupComponent(component);
  }
});
